// Public: Returns the height and width for the provided image file.
export function imageSizeFor (file: File): Promise<{ height: number; width: number }> {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file)

    const image = new Image()
    image.src = objectUrl
    image.onerror = reject
    image.onload = () => {
      const { height, width } = image
      URL.revokeObjectURL(objectUrl)
      resolve({ height, width })
    }
  })
}
